$(document).ready(function() {
    //Prevent spam crawlers from getting our email addresses.
    $('[data-user][data-domain]').each(function() {
        const emailAddress = $(this).data('user') + '@' + $(this).data('domain');
        $(this).html(emailAddress).attr('href', 'mailto:' + emailAddress);
    });
});
